import { useCallback } from 'react';
import noop from 'lodash/noop';
import { useAccordionContext } from '../use-accordion-context';
import { useAccordionRef } from '../use-accordion-ref';
export var useAccordionItem = function useAccordionItem() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop : _ref$onClick;

  var _useAccordionRef = useAccordionRef(),
      isExpanded = _useAccordionRef.isExpanded,
      ref = _useAccordionRef.ref;

  var _useAccordionContext = useAccordionContext(),
      onToggle = _useAccordionContext.onToggle;
  /**
   * Handles keyboard and mouse event bivariance
   * @internal
   */


  var _handlePress = useCallback(function (e) {
    onToggle(ref);
    onClick(e);
  }, [ref, onClick, onToggle]);

  var handleClick = useCallback(function (e) {
    _handlePress(e);
  }, [_handlePress]);
  var handleKeyDown = useCallback(function (e) {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();

      _handlePress(e);
    }
  }, [_handlePress]);
  return {
    isExpanded: isExpanded,
    ref: ref,
    handleClick: handleClick,
    handleKeyDown: handleKeyDown
  };
};